'use client';

import { PostNotFound } from 'src/sections/blog/components/post-not-found';

// ----------------------------------------------------------------------

/** 상세 렌더 중 오류 — 없는 글과 같은 화면을 보여 준다(error·reset 은 쓰지 않는다) */
export default function Error(_props: { error: Error & { digest?: string }; reset: () => void }) {
  return <PostNotFound />;
}
